import { IBlockPack } from "../../core/engine/packs/blocks/IBlockPack";
import { IBlockPackFactoryImpl } from "../../core/engine/packs/blocks/IBlockPackFactoryImpl";
import { BlockPackType } from "../../core/engine/packs/blocks/BlockPackFactory";
import DefaultBlockPack from "../../core/engine/packs/blocks/DefaultBlockPack";
import RoundedBlockPack from "../../core/engine/packs/blocks/RoundedBlockPack";
import CementBlockPack from "../../core/engine/packs/blocks/CementBlockPack";
import GlassBlockPack from "../../core/engine/packs/blocks/GlassBlockPack";

export class ClientBlockPackFactory implements IBlockPackFactoryImpl {
  createPack(type: BlockPackType): IBlockPack {
    switch (type) {
      case "fancy":
        return new RoundedBlockPack();
      case "cement":
        return new CementBlockPack();
      case "glass":
        return new GlassBlockPack();
      case "default":
      default:
        return new DefaultBlockPack();
    }
  }
}

